<template>
  <div class="about" id="about">
    <div class="flex items-center justify-center align-center">
      <div class="w-1/6 h-1 bg-gray-500 rounded-sm"></div>
      <h1 class="px-8 py-8 text-3xl font-bold primary">
        A Propos de ce projet
      </h1>
      <div class="w-1/6 h-1 bg-gray-500 rounded-sm"></div>
    </div>

    <div class="flex items-center justify-center px-20 align-center gap-x-20">
      <div class="w-1/3">
        <p class="py-5 text-xl text-justify text-[#696969]">
          FreeTalk est une plateforme en ligne interactive dédiée à la
          communication libre et dynamique entre utilisateurs du monde entier.
          Le site offre des fonctionnalités variées telles que des forums de
          discussion, des salles de chat en temps réel, et des blogs où chacun
          peut partager ses idées, poser des questions ou débattre de sujets
          d'actualité. Avec une interface intuitive et conviviale, FreeTalk
          favorise les échanges interculturels, permettant aux membres de
          développer leur réseau social tout en améliorant leurs compétences en
          communication. En mettant l'accent sur la diversité et l'inclusion,
        </p>
        <p class="py-5 text-xl text-justify text-[#696969]">
          FreeTalk encourage un environnement où toutes les voix peuvent
          s'exprimer librement, soutenu par des modérateurs veillant à maintenir
          un espace respectueux et positif.
        </p>
        <img
          src="../../../assets/about1.jpg"
          alt=""
          srcset=""
          class="mb-8 rounded-sm"
        />
      </div>
      <div class="w-1/3">
        <div
          class="flex flex-col items-start justify-start align-start p-5 rounded-lg bg-[#D9D9D9] my-10"
        >
          <p class="mb-4 text-2xl font-bold text-black">Problématique</p>
          <p class="text-justify text-[#696969]">
            Dans un contexte où la liberté d'expression est souvent mise à
            l'épreuve par la montée des discours de haine, la désinformation et
            les atteintes à la vie privée sur les réseaux sociaux, comment
            garantir un espace sûr et inclusif qui permette à chacun de partager
            ses opinions sans craindre des répercussions négatives ou des
            violences verbales, tout en maintenant la nécessité d'une modération
            efficace pour prévenir les abus ?
          </p>
        </div>
        <div
          class="flex flex-col items-start justify-start align-start p-5 rounded-lg bg-[#D9D9D9]"
        >
          <p class="mb-4 text-2xl font-bold text-black">Solution</p>
          <p class="text-justify text-[#696969]">
            FreeTalk est une application innovante conçue pour promouvoir la
            liberté d'expression au sein d'une communauté tout en assurant un
            environnement de dialogue respectueux et sécurisé. Elle permet aux
            utilisateurs de partager librement leurs idées, opinions et
            expériences, tout en intégrant des fonctionnalités de modération
            collaborative. L'application utilise également l'intelligence
            artificielle pour détecter les discours de haine et la
            désinformation. FreeTalk propose aussi des ressources éducatives et
            des ateliers en ligne pour promouvoir le respect mutuel, ainsi qu'un
            système de soutien pour les victimes d'abus, visant à créer un
            espace où la liberté d'expression peut s'épanouir tout en préservant
            civisme et respect.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.about {
  background: white;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
